<template>
  <div>
    <transition name="bounce">
      <div v-if="releaseUpdated || subscriptionUpdated || featureFlagChanged" class="update-notification">
        <div class="d-flex align-items-center">
          <div class="d-flex flex-column">
            <div v-if="releaseUpdated || featureFlagChanged" class="update-text">
              <h6 class="mb-0 font-weight-midbold">{{ $t(isImportant ? 'extra.new_important_release' : 'extra.new_release') }}</h6>
              <div v-if="isImportant">
                {{ $t('extra.new_release_description') }} <b>{{ secondsBeforeRefresh }} sek. </b>
                <template v-if="willDataBeSaved">{{ $t('extra.info_will_be_saved') }}</template>
              </div>
            </div>

            <template v-if="subscriptionUpdated">
              <div class="font-weight-midbold">
                {{ $t('extra.plan_renewed') }}
              </div>
            </template>
          </div>

          <s-button class="update-btn-black ml-2" @click="reloadPage">
            <refresh-icon class="text-white"/>
            <span class="font-weight-midbold">{{ $t('actions.update') }}</span>
          </s-button>
        </div>

        <progress-animation-bar v-if="isImportant" @end="reloadPage" :animation-duration="secondsBeforeRefresh" class="mt-2"/>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import RefreshIcon from '@/components/icons/refresh.vue';
  import ProgressAnimationBar from '@/components/progress/progress-animation.vue';
  import { routerService } from '@/core';
  import { useUpdateStore } from '@/stores/update';
  import { useAuthStore } from '@/stores/auth.ts';
  import { ref, computed } from 'vue';
  import { useRouter } from 'vue-router';

  const secondsBeforeRefresh = ref(60);
  const updateStore = useUpdateStore();
  const authStore = useAuthStore();
  const router = useRouter();

  const isImportant = computed(() => updateStore.refresh_version_mismatch);

  const subscriptionUpdated = computed(() => authStore.subscription_mismatch);

  const releaseUpdated = computed(() => updateStore.mismatch || updateStore.refresh_version_mismatch);

  const willDataBeSaved = computed(() => routerService.current.name === 'invoice.create');

  const featureFlagChanged = computed(() => authStore.feature_flags_changed);

  function reloadPage() {
    if (routerService.current.name === 'invoice.create') {
      window.location.replace(router.resolve({ name: 'invoice.index' }).href);
    } else {
      window.location.reload();
    }
  }
</script>
